import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("image2", component(opts));
  editor.BlockManager.add("image2", block(opts));
};